module.exports = __webpack_public_path__ + "static/media/btn-click.97698a53.mp3";